import { FunctionComponent } from 'react';

interface RenderRichTextProps {
    html: string;
}

const RenderRichText: FunctionComponent<RenderRichTextProps> = ({ html }) => {
    return (
        <div
            className="mb-2 text-base leading-3 list-disc rich-text"
            dangerouslySetInnerHTML={{
                __html: html,
            }}
        ></div>
    );
};

export default RenderRichText;
